var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "addons_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 15,
    height: 15,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.213,
    y: 4.213,
    width: 14.573,
    height: 14.573,
    rx: 1.943,
    transform: "rotate(-45 36.5 11.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 15,
    height: 15,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 29,
    width: 15,
    height: 15,
    rx: 2
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+YXBwIHN0b3JlPC90aXRsZT48ZyBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMjcyNzI2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibmMtaWNvbi13cmFwcGVyIj48cmVjdCB4PSI0IiB5PSI0IiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHJ4PSIyIj48L3JlY3Q+PHJlY3QgeD0iMjkuMjEzIiB5PSI0LjIxMyIgd2lkdGg9IjE0LjU3MyIgaGVpZ2h0PSIxNC41NzMiIHJ4PSIxLjk0MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMi41NTkgMjkuMTc4KSByb3RhdGUoLTQ1KSIgc3Ryb2tlPSIjMjcyNzI2Ij48L3JlY3Q+PHJlY3QgeD0iMjkiIHk9IjI5IiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHJ4PSIyIj48L3JlY3Q+PHJlY3QgeD0iNCIgeT0iMjkiIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgcng9IjIiPjwvcmVjdD48L2c+PC9zdmc+";
export { SvgAddons as ReactComponent };